import { User } from "../user/User"

export class OrderPaymentDetails {
  amount: number
  receivedDate: string
  receivedByUser: User

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(amount: number, receivedDate: string, receivedByUserJson: any) {
    this.amount = amount
    this.receivedDate = receivedDate
    this.receivedByUser = new User(receivedByUserJson)
  }
}